import { format } from 'date-fns';

export const byTime = (needle?: Date) =>
  needle === undefined
    ? () => false
    : (hay: Date) => format(needle, 'HH:mm') === format(hay, 'HH:mm');
